var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "home-msg",
    },
    [
      _c(
        "div",
        { staticClass: "home-msg_title spaceBetween" },
        [
          _vm._v("\n    Unread Messages\n    "),
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.goToMore } },
            [
              _vm._v("See more"),
              _c("i", { staticClass: "el-icon-d-arrow-right" }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-collapse",
        {
          staticClass: "home-msg_collapse",
          attrs: { accordion: "" },
          on: { change: _vm.changeOpen },
          model: {
            value: _vm.activeCollapse,
            callback: function ($$v) {
              _vm.activeCollapse = $$v
            },
            expression: "activeCollapse",
          },
        },
        _vm._l(_vm.dataList, function (item, index) {
          return _c(
            "el-collapse-item",
            {
              key: index,
              class: { "is-readed": +item.status !== 0 },
              attrs: { name: item.msgID },
            },
            [
              _c("template", { slot: "title" }, [
                _c(
                  "div",
                  { staticClass: "spaceBetween home-msg_collapse_head" },
                  [
                    _c(
                      "div",
                      [
                        _c("svg-icon", {
                          staticClass: "icon-arrow",
                          attrs: { "icon-class": "tn-jiantou" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.title))]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "time-text" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.moment(item.timestamp).fromNow()) +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("pre", { staticClass: "msg-desc" }, [
                _vm._v("        " + _vm._s(item.description) + "\n      "),
              ]),
            ],
            2
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.dataList.length == 0
        ? _c("div", { staticClass: "msg-empty" }, [_vm._v("No Data")])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }